var XPortal = XPortal || {};
XPortal.DataWizard = (function () {
    function InitFor(cnrol) {
        cnrol = cnrol ? $(cnrol) : false;
        if (!(cnrol) || cnrol.length < 1) return;
        cnrol.off('click', '.wizard-action');
        cnrol.on('click', '.wizard-action', function () {
            Save(cnrol);
        });
    };
    function Save(cont) {
        let options = { container: cont };
        var modelName = XPortal.Store.getModelName(cont);
        XPortal.Store.DispatchNoAutoSave(modelName, "_newrecord", false);
        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_START, modelName });
        return XPortal.EditForm.SaveData(modelName, options);
    };
    var self =
    {
        Reloaded: function (selector, oncallback, modelName, extramodel) {
            self.Init();
            XPortal.EditForm.Reloaded(selector, oncallback, modelName, extramodel);
        },
        Init: function (cntr) {
            cntr = $(cntr ? cntr : "body");
            cntr.find(".data-wizard").each(function () {
                InitFor(this);
            });
        }
    };

    return self;
}());